{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Cancel·la",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Integracions",
    "DESCRIPTION": "El centre de contacte s'integra amb diverses eines i serveis per millorar l'eficiència del vostre equip. Exploreu la llista següent per configurar les vostres aplicacions preferides.",
    "LEARN_MORE": "Learn more about integrations",
    "LOADING": "Fetching integrations",
    "CAPTAIN": {
      "DISABLED": "Captain is not enabled on your account.",
      "CLICK_HERE_TO_CONFIGURE": "Click here to configure",
      "LOADING_CONSOLE": "Loading Captain Console...",
      "FAILED_TO_LOAD_CONSOLE": "Failed to load Captain Console. Please refresh and try again."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Esdeveniments subscrits",
      "LEARN_MORE": "Learn more about webhooks",
      "FORM": {
        "CANCEL": "Cancel·la",
        "DESC": "Els esdeveniments de Webhook us proporcionen informació en temps real sobre el que passa al vostre compte. Introduïu una URL vàlida per configurar un callback.",
        "SUBSCRIPTIONS": {
          "LABEL": "Esdeveniments",
          "EVENTS": {
            "INBOX_CREATED": "Safata d'entrada creada",
            "CONVERSATION_CREATED": "Conversa Creada",
            "CONVERSATION_STATUS_CHANGED": "Estat de la conversa canviat",
            "CONVERSATION_UPDATED": "Conversa Actualitzada",
            "MESSAGE_CREATED": "Missatge creat",
            "MESSAGE_UPDATED": "Missatge actualitzat",
            "WEBWIDGET_TRIGGERED": "Widget de xat en directe obert per l'usuari",
            "CONTACT_CREATED": "Contacte creat",
            "CONTACT_UPDATED": "Contacte actualitzat",
            "JARABOT_EVENT": "Esdeveniments interns"
          }
        },
        "END_POINT": {
          "LABEL": "URL del webhook",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "Introduïu una URL vàlid"
        },
        "EDIT_SUBMIT": "Webhook actualitzat",
        "ADD_SUBMIT": "Crear webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Configura",
      "HEADER": "Configuració Webhook",
      "HEADER_BTN_TXT": "Afegeix un nou webhook",
      "LOADING": "S'estan recollint els webhooks adjunts",
      "SEARCH_404": "No hi ha articles que coincideixin amb aquesta consulta",
      "SIDEBAR_TXT": "<p><b>Webhooks</b> </p> <p>Els webhooks són callbacks HTTP que es poden definir per a cada compte. Es produeixen per esdeveniments com la creació de missatges. Podeu crear més d'un webhook per a aquest compte. <br /><br /> Per crear un <b>webhook</b>, feu clic al botó <b> Afegir nou webhook </b>. També podeu eliminar qualsevol webhook existent fent clic al botó Elimina.</p>",
      "LIST": {
        "404": "No hi ha cap webhooks configurat per a aquest compte.",
        "TITLE": "Gestiona els webhooks",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Punt final del webhook",
          "ACTIONS": "Accions"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Edita",
        "TITLE": "Edita el webhook",
        "API": {
          "SUCCESS_MESSAGE": "La configuració del webhook s'ha actualitzat correctament",
          "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant"
        }
      },
      "ADD": {
        "CANCEL": "Cancel·la",
        "TITLE": "Afegir un nou webhook",
        "API": {
          "SUCCESS_MESSAGE": "La configuració del webhook s'ha afegit correctament",
          "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Suprimeix",
        "API": {
          "SUCCESS_MESSAGE": "S'ha esborrat el Webhook correctament",
          "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant"
        },
        "CONFIRM": {
          "TITLE": "Confirma l'esborrat",
          "MESSAGE": "N'estàs segur que suprimiu el webhook? ({webhookURL})",
          "YES": "Si, esborra ",
          "NO": "No, mantén-la"
        }
      },
      "DISABLED_BADGE": "Desactivat",
      "DISABLED_REASON": "Desactivat automàticament després de {count} errors consecutius. Últim error: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Activa",
        "API": {
          "SUCCESS_MESSAGE": "El webhook s'ha activat correctament",
          "ERROR_MESSAGE": "No s'ha pogut activar el webhook. Torna-ho a provar més endavant"
        }
      }
    },
    "SLACK": {
      "DELETE": "Esborrar",
      "DELETE_CONFIRMATION": {
        "TITLE": "Suprimeix la integració",
        "MESSAGE": "N'estàs segur que vols suprimir la integració? Si ho fas, es perdrà l'accés a les converses del vostre espai de treball de Slack."
      },
      "HELP_TEXT": {
        "TITLE": "Com utilitzar la integració de Slack?",
        "BODY": "Amb aquesta integració, totes les converses entrants se sincronitzaran amb el canal ***{selectedChannelName}*** del vostre espai de treball de Slack. Podeu gestionar totes les converses amb els clients directament dins del canal i no perdreu mai cap missatge.\n\nAquestes són les funcions principals de la integració:\n\n**Respondre a converses des de Slack:** Per respondre a una conversa al canal de Slack ***{selectedChannelName}***, escriviu el missatge i envieu-lo com a fil. Això crearà una resposta al client a través del centre de contacte. Així de senzill!\n\n **Crear notes privades:** Si voleu crear notes privades en lloc de respostes, comenceu el missatge amb ***`note:`***. Així el missatge es manté privat i el client no el veurà.\n\n**Associar un perfil d'agent:** Si la persona que ha respost a Slack té un perfil d'agent al centre de contacte amb el mateix correu electrònic, les respostes s'associaran automàticament a aquest perfil d'agent. Això vol dir que podeu fer el seguiment fàcilment de qui ha dit què i quan. D'altra banda, si qui respon no té cap perfil d'agent associat, el client veurà les respostes des del perfil del bot.",
        "SELECTED": "seleccionat"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Selecciona el canal",
        "UPDATE": "Actualitza",
        "BUTTON_TEXT": "Connecta el canal",
        "DESCRIPTION": "El teu espai de treball de Slack ara està enllaçat amb el centre de contacte. Tanmateix, actualment la integració està inactiva. Per activar la integració i connectar un canal, feu clic al botó següent.\n\n**Nota:** si estas intentant connectar un canal privat, afegeix la nostra aplicació al canal de Slack abans de continuar amb aquest pas.",
        "ATTENTION_REQUIRED": "Es requereix atenció",
        "EXPIRED": "La teva integració de Slack ha caducat. Per continuar rebent missatges a Slack, suprimeix la integració i torna a connectar el vostre espai de treball."
      },
      "UPDATE_ERROR": "S'ha produït un error en actualitzar la integració, torna-ho a provar",
      "UPDATE_SUCCESS": "El canal s'ha connectat correctament",
      "FAILED_TO_FETCH_CHANNELS": "S'ha produït un error en obtenir els canals de Slack, torna-ho a provar"
    },
    "OPEN_AI": {
      "AI_ASSIST": "Assistència IA",
      "WITH_AI": " {option} amb IA ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Suggeriment de resposta",
        "SUMMARIZE": "Resumir",
        "REPHRASE": "Millorar l'escriptura",
        "FIX_SPELLING_GRAMMAR": "Corregir l'ortografia i la gramàtica",
        "SHORTEN": "Abreuja",
        "EXPAND": "Expandeix",
        "MAKE_FRIENDLY": "Canvia el to del missatge a amigable",
        "MAKE_FORMAL": "Utilitza un to formal",
        "SIMPLIFY": "Simplifica",
        "TRANSLATE": "Tradueix",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Tradueix a la llengua majoritària"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Esborrany de contingut",
        "GENERATED_TITLE": "Contingut generat",
        "AI_WRITING": "La IA està escrivint",
        "BUTTONS": {
          "APPLY": "Utilitza aquest suggeriment",
          "CANCEL": "Cancel·la"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integració amb OpenAI",
        "DESC": "Aporta funcions d'IA avançades al teu tauler amb els models GPT d'OpenAI. Per començar, introdueix la clau API del teu compte d'OpenAI.",
        "KEY_PLACEHOLDER": "Introdueix la vostra API key d'OpenAI",
        "BUTTONS": {
          "NEED_HELP": "Necessita ajuda?",
          "DISMISS": "Descartar",
          "FINISH": "Finalitza la configuració"
        },
        "DISMISS_MESSAGE": "Pots configurar la integració d'OpenAI més tard quan vulguis.",
        "SUCCESS_MESSAGE": "S'ha configurat correctament la integració d'OpenAI"
      },
      "TITLE": "Millora amb IA",
      "SUMMARY_TITLE": "Resum amb IA",
      "REPLY_TITLE": "Respon el suggeriment amb IA",
      "SUBTITLE": "Es generarà una resposta millorada mitjançant IA, basada en el teu esborrany actual.",
      "TONE": {
        "TITLE": "To",
        "OPTIONS": {
          "PROFESSIONAL": "Professional",
          "FRIENDLY": "Amable"
        }
      },
      "BUTTONS": {
        "GENERATE": "Genera",
        "GENERATING": "Generant...",
        "CANCEL": "Cancel·la"
      },
      "GENERATE_ERROR": "There was an error processing the content, please try again"
    },
    "DELETE": {
      "BUTTON_TEXT": "Suprimeix",
      "API": {
        "SUCCESS_MESSAGE": "La integració s'ha suprimit correctament"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Connectar"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Aplicacions del tauler de control",
      "HEADER_BTN_TXT": "Afegeix una aplicació de tauler nova",
      "SIDEBAR_TXT": "<p><b>Aplicacions del tauler de control</b></p><p>Les aplicacions del tauler de control permeten a les organitzacions incrustar una aplicació dins del tauler de control per proporcionar el context als agents d'atenció al client. Aquesta funció et permet crear una aplicació de manera independent i inserir-la dins del tauler per proporcionar informació de l'usuari, les seves comandes o el seu historial de pagaments anteriors.</p><p>Quan incrusteu la teva aplicació al tauler de control, la teva aplicació obté el context de la conversa i el contacte com a esdeveniment de finestra. Implementa un oient per a l'esdeveniment del missatge a la teva pàgina per rebre el context.</p><p>Per afegir una aplicació de tauler nova, feu clic al botó \"Afegeix una aplicació de tauler nova\".</p>",
      "DESCRIPTION": "Les aplicacions del tauler permeten a les organitzacions incrustar una aplicació dins del tauler per proporcionar el context als agents d'atenció al client. Aquesta funció et permet crear una aplicació de manera independent i incorporar-la per proporcionar informació de l'usuari, les seves comandes o el seu historial de pagaments anterior.",
      "LEARN_MORE": "Learn more about Dashboard Apps",
      "LIST": {
        "404": "Encara no hi ha cap aplicació de tauler configurada en aquest compte",
        "LOADING": "S'estan obtenint les aplicacions del tauler de control...",
        "TABLE_HEADER": {
          "NAME": "Nom",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Edita l'aplicació",
        "DELETE_TOOLTIP": "Suprimeix l'aplicació"
      },
      "FORM": {
        "TITLE_LABEL": "Nom",
        "TITLE_PLACEHOLDER": "Introdueix un nom per a l'aplicació del tauler",
        "TITLE_ERROR": "Un nom per a l'aplicació del tauler és obligatori",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Introdueix l'URL del punt final on està allotjada la teva aplicació",
        "URL_ERROR": "Una URL vàlida és obligatoria"
      },
      "CREATE": {
        "HEADER": "Afegeix una aplicació de tauler nova",
        "FORM_SUBMIT": "Envia",
        "FORM_CANCEL": "Cancel·la",
        "API_SUCCESS": "L'aplicació del tauler de control s'ha configurat correctament",
        "API_ERROR": "No hem pogut crear una aplicació. Intenta-ho més tard"
      },
      "UPDATE": {
        "HEADER": "Edita l'aplicació del tauler",
        "FORM_SUBMIT": "Actualitza",
        "FORM_CANCEL": "Cancel·la",
        "API_SUCCESS": "L'aplicació del tauler de control s'ha actualitzat correctament",
        "API_ERROR": "No hem pogut actualitzar l'aplicació. Intenta-ho més tard"
      },
      "DELETE": {
        "CONFIRM_YES": "Sí, esborra-ho",
        "CONFIRM_NO": "No, mantén-la",
        "TITLE": "Confirma la supressió",
        "MESSAGE": "N'estàs segur que vols suprimir l'aplicació - {appName}?",
        "API_SUCCESS": "L'aplicació del tauler de control s'ha esborrat correctament",
        "API_ERROR": "No hem pogut esborrar l'aplicació. Intenta-ho més tard"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Crear/enllaçar una issue en Linear",
      "LOADING": "S'estan buscant issues en Linear...",
      "LOADING_ERROR": "S'ha produït un error en obtenir les issues en Linear, torna-ho a provar",
      "CREATE": "Crear",
      "LINK": {
        "SEARCH": "Cerca issues",
        "SELECT": "Selecciona una issue",
        "TITLE": "Enllaç",
        "EMPTY_LIST": "No s'han trobat issues de Linear",
        "LOADING": "Carregant",
        "ERROR": "S'ha produït un error en obtenir les issues en Linear, torna-ho a provar",
        "LINK_SUCCESS": "S'ha enllaçat la issue correctament",
        "LINK_ERROR": "S'ha produït un error en enllaçar la issue, torna-ho a provar",
        "LINK_TITLE": "Conversation (#{conversationId}) with {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Crear/enllaçar una issue en Linear",
        "DESCRIPTION": "Crea issues en Linear a partir de converses o enllaça els existents per fer un seguiment perfecte.",
        "FORM": {
          "TITLE": {
            "LABEL": "Títol",
            "PLACEHOLDER": "Introdueix un títol",
            "REQUIRED_ERROR": "El títol és necessari"
          },
          "DESCRIPTION": {
            "LABEL": "Descripció",
            "PLACEHOLDER": "Introdueix la descripció"
          },
          "TEAM": {
            "LABEL": "Equip",
            "PLACEHOLDER": "Selecciona equip",
            "SEARCH": "Cerca equip",
            "REQUIRED_ERROR": "Un equip és necessari"
          },
          "ASSIGNEE": {
            "LABEL": "Cessionari",
            "PLACEHOLDER": "Selecciona assignat",
            "SEARCH": "Cerca assignat"
          },
          "PRIORITY": {
            "LABEL": "Prioritat",
            "PLACEHOLDER": "Selecciona la prioritat",
            "SEARCH": "Cerca prioritat"
          },
          "LABEL": {
            "LABEL": "Etiqueta",
            "PLACEHOLDER": "Selecciona l'etiqueta",
            "SEARCH": "Cerca etiqueta"
          },
          "STATUS": {
            "LABEL": "Estat",
            "PLACEHOLDER": "Selecciona l'estat",
            "SEARCH": "Cerca l'estat"
          },
          "PROJECT": {
            "LABEL": "Projecte",
            "PLACEHOLDER": "Selecciona el projecte",
            "SEARCH": "Cerca el projecte"
          }
        },
        "CREATE": "Crear",
        "CANCEL": "Cancel·la",
        "CREATE_SUCCESS": "Issue creada correctament",
        "CREATE_ERROR": "S'ha produït un error en crear la issue, torna-ho a provar",
        "LOADING_TEAM_ERROR": "S'ha produït un error en obtenir els equips, torna-ho a provar",
        "LOADING_TEAM_ENTITIES_ERROR": "S'ha produït un error en recuperar les entitats de l'equip, torna-ho a provar"
      },
      "ISSUE": {
        "STATUS": "Estat",
        "PRIORITY": "Prioritat",
        "ASSIGNEE": "Cessionari",
        "LABELS": "Etiquetes",
        "CREATED_AT": "Created at {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Desenllaça",
        "SUCCESS": "S'ha desenllaçat la issue correctament",
        "ERROR": "S'ha produït un error en desenllaçar la issue, torna-ho a provar"
      },
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Sí, esborra",
        "CANCEL": "Cancel·la"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Know more",
    "COPILOT": {
      "SEND_MESSAGE": "Envia missatge...",
      "EMPTY_MESSAGE": "S'ha produït un error en generar la resposta. Torna-ho a provar.",
      "LOADER": "Captain is thinking",
      "YOU": "Tu",
      "USE": "Use this",
      "RESET": "Reset",
      "SELECT_ASSISTANT": "Select Assistant"
    },
    "PAYWALL": {
      "TITLE": "Upgrade to use Captain AI",
      "AVAILABLE_ON": "Captain is not available on the free plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "UPGRADE_NOW": "Actualitza ara",
      "CANCEL_ANYTIME": "Pots canviar o cancel·lar el teu pla en qualsevol moment"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI feature is only available in a paid plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "ASK_ADMIN": "Posa't en contacte amb el vostre administrador per obtenir l'actualització."
    },
    "BANNER": {
      "RESPONSES": "You've used over 80% of your response limit. To continue using Captain AI, please upgrade.",
      "DOCUMENTS": "Document limit reached. Upgrade to continue using Captain AI."
    },
    "FORM": {
      "CANCEL": "Cancel·la",
      "CREATE": "Crear",
      "EDIT": "Actualitza"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "Sí, esborra",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Assistant Name",
          "PLACEHOLDER": "Enter a name for the assistant",
          "ERROR": "Please provide a name for the assistant"
        },
        "DESCRIPTION": {
          "LABEL": "Assistant Description",
          "PLACEHOLDER": "Describe how and where this assistant will be used",
          "ERROR": "A description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter the name of the product this assistant is designed for",
          "ERROR": "The product name is required"
        },
        "FEATURES": {
          "TITLE": "Característiques",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions."
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "DESCRIPTION": "These FAQs are generated directly from the document."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select the assistant",
          "ERROR": "The assistant field is required"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "Sí, esborra",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "View Related Responses",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQs",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "Esborrar",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Sí, esborra",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Totes"
      },
      "STATUS": {
        "TITLE": "Estat",
        "PENDING": "Pendent",
        "APPROVED": "Approved",
        "ALL": "Totes"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select an assistant",
          "ERROR": "Please select an assistant."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Mark as approved",
        "EDIT_RESPONSE": "Edit FAQ",
        "DELETE_RESPONSE": "Delete FAQ"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "Desconnecta"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Sí, esborra",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Safata d'entrada",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
